var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"large-background-outer"},[_vm._m(0),(_vm.IsDark)?_c('div',{staticClass:"dark-overlay"}):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"outer-content"},[_c('div',{staticClass:"large-background"})])
}]

export { render, staticRenderFns }